import { render } from "./AvatarRow.vue?vue&type=template&id=5e1fc4fb&scoped=true"
import script from "./AvatarRow.vue?vue&type=script&lang=js"
export * from "./AvatarRow.vue?vue&type=script&lang=js"

import "./AvatarRow.vue?vue&type=style&index=0&id=5e1fc4fb&lang=scss&scoped=true"

import exportComponent from "/root/workspace/bjyx-h5_Pbc0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e1fc4fb"]])

export default __exports__